
import { PageService } from "@/api";
import {
    PAGE_FETCH,
    PAGE_SET,
    PAGE_RESET,
} from "@/store/actions.type";

import {
    FETCH_START,
    FETCH_END,
    SET_PAGE,
    RESET_PAGE,
    SET_SLUG,
} from "@/store/mutations.type";

const state = () => ({
    isLoading: false,
    slug: '',
    pages: {},
});

const actions = {

    async [PAGE_FETCH]({ commit, state }, slug) {

        if (state.pages.hasOwnProperty(slug)) {
            commit(SET_SLUG, slug);
            return;
        }

        commit(FETCH_START);

        try {
            const { data } = await PageService.get(slug);
            commit(SET_PAGE, { ...data, slug });

            return data;
        } catch(e) {
            commit(FETCH_END);

            throw e;
        }

        return null;
    },

    [PAGE_SET]({ commit }, data) {

        commit(SET_PAGE, data);

        return data;
    },

    [PAGE_RESET]({ commit }) {

        commit(RESET_PAGE);

        return true;
    },
};

const mutations = {

    [FETCH_START](state) {
        state.isLoading = true;
    },

    [FETCH_END](state) {
        state.isLoading = false;
    },

    [SET_SLUG](state, slug) {
        state.slug = slug;
    },

    [SET_PAGE](state, { sections, slug}) {

        state.slug = slug;
        state.isLoading = false;
        state.pages[slug] = {
            sections
        };
    },

    [RESET_PAGE](state) {

        state.slug = '';
        state.isLoading = false;
        state.pages = {};
    }
};

const getters = {
    isLoading: (state) => {
        return state.isLoading;
    },

    getSections: (state) => {
        if (!state.pages[state.slug]) { return null; }

        return state.pages[state.slug].sections;
    },

    getJumpmarks: (state) => {
        if (!state.pages[state.slug]) { return null; }

        const jumpmarkSections = state.pages[state.slug].sections.filter((section) => {
            return section.type == 'section-jumpmark';
        });

        return jumpmarkSections.reduce((currentValue, section) => {
            return [
                ...currentValue,
                section.component.jumpmark
            ];
        }, []);
    },
};


export const page = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
